export default __webpack_public_path__ + "static/media/e3.352b7735.svg";